import { forwardRef } from "react";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";

interface PhoneNumberInputProps {
  value?: string;
  onChange: (value: string | undefined) => void;
  error?: boolean;
}
const isProd = process.env.REACT_APP_STAGE === "production";

const PhoneNumberInput = forwardRef<HTMLInputElement, PhoneNumberInputProps>(
  ({ value, onChange, error }, ref) => {
    return (
      <div className={`${isProd ? "is_production" : ""}`}>
        <PhoneInput
          placeholder="Enter your phone number"
          value={value}
          onChange={onChange ?? (() => {})}
          international
          defaultCountry="AU"
          countryCallingCodeEditable={false}
          style={{
            padding: "12px",
            border: error ? "2px solid #ff0000" : "2px solid #EAECF0",
            borderRadius: "10px",
            fontSize: "16px",
            "--PhoneInputCountryFlag-width": "28px",
            "--PhoneInputCountryFlag-height": "20px",
            "--PhoneInputCountryFlag-borderColor": "#eee",
          }}
          className="phoneNumber_wrapper"
          // countrySelectProps={{
          //   style: {
          //     padding: "8px",
          //     backgroundColor: "#f9f9f9",
          //   },
          // }}
          countrySelectProps={
            isProd
              ? {
                  disabled: true,
                  style: {
                    display: "none",
                  },
                }
              : {
                  style: {
                    padding: "8px",
                    backgroundColor: "#f9f9f9",
                  },
                }
          }
          inputRef={ref}
        />
      </div>
    );
  }
);

PhoneNumberInput.displayName = "PhoneNumberInput";

export default PhoneNumberInput;
